<template>
  <treeselect v-model="val"
              :size='size'
              :maxHeight='maxHeight'
              :options="options"
              :multiple="multiple"
              :disabled="disabled"
              :loadOptions="loadOptions"
              :placeholder="placeholder"
              @input="$emit('change', $event)" />
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    size: {
      default: "mini"
    },
    options: {},
    multiple: {
      default: false
    },
    disabled: {
      default: false
    },
    value: {},
    placeholder: {
      default: ''
    },
    maxHeight: {
      type: Number,
      default: 100
    }
  },
  data() {
    return {
      val: this.value || null
    }
  },
  watch: {
    value: function(value) {
      this.val = value;
    }
  },
  methods: {
    loadOptions({ action, parentNode, callback }) {
    },
  }
};
</script>
<style scoped>
  .vue-treeselect__menu-container
  {
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/cx/cxTreeSelect.vue